import {
  CreateWithContractDocument,
  CreateWithContractMutationVariables,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

export const useCreateEmployeeWithContract = () => {
  const [createWithContract, { loading }] = useMutation(CreateWithContractDocument, {
    extractorFn: (data) => data.employeesMutations.createWithContractEmployeesEmployee,
  })

  return {
    loading,
    createEmployeeWithContract(variables: CreateWithContractMutationVariables) {
      return createWithContract({
        variables,
      })
    },
  }
}
